export default __webpack_public_path__ + "static/media/F2.7c6b7fd0.gif";